var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "application-pdf-editor"
  }, [_vm.loading ? _c('div', {
    staticClass: "editor-status",
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "30",
      "width": "3",
      "indeterminate": ""
    }
  }), _vm._m(0)], 1) : _vm.error ? _c('div', {
    staticClass: "editor-status editor-error",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Žiadosť sa nepodarilo otvoriť na editáciu.")]), _c('span', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.loading && !_vm.error,
      expression: "!loading && !error"
    }],
    staticClass: "editor-scroll"
  }, _vm._l(_vm.pages, function (page) {
    return _c('div', {
      key: page.number,
      staticClass: "editor-page",
      style: {
        width: "".concat(page.width, "px"),
        height: "".concat(page.height, "px")
      },
      attrs: {
        "data-page-number": page.number
      }
    }, [_c('canvas', {
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('div', {
      staticClass: "editor-fields"
    }, [_vm._l(page.fields, function (field) {
      return [field.type === 'text' && field.multiLine ? _c('textarea', {
        key: field.id,
        staticClass: "pdf-form-field pdf-text-field pdf-textarea",
        style: field.style,
        attrs: {
          "aria-label": field.name,
          "maxlength": field.maxLength || null
        },
        domProps: {
          "value": _vm.fieldValue(field.name)
        },
        on: {
          "input": function input($event) {
            return _vm.updateValue(field.name, $event.target.value);
          }
        }
      }) : field.type === 'text' ? _c('input', {
        key: field.id,
        staticClass: "pdf-form-field pdf-text-field",
        style: field.style,
        attrs: {
          "type": "text",
          "aria-label": field.name,
          "maxlength": field.maxLength || null
        },
        domProps: {
          "value": _vm.fieldValue(field.name)
        },
        on: {
          "input": function input($event) {
            return _vm.updateValue(field.name, $event.target.value);
          }
        }
      }) : field.type === 'checkbox' ? _c('input', {
        key: field.id,
        staticClass: "pdf-form-field pdf-checkbox-field",
        style: field.style,
        attrs: {
          "type": "checkbox",
          "aria-label": field.name
        },
        domProps: {
          "checked": Boolean(_vm.fieldValue(field.name))
        },
        on: {
          "change": function change($event) {
            return _vm.updateValue(field.name, $event.target.checked);
          }
        }
      }) : field.type === 'radio' ? _c('input', {
        key: field.id,
        staticClass: "pdf-form-field pdf-radio-field",
        style: field.style,
        attrs: {
          "type": "radio",
          "name": field.name,
          "aria-label": field.name
        },
        domProps: {
          "value": field.exportValue,
          "checked": _vm.fieldValue(field.name) === field.exportValue
        },
        on: {
          "change": function change($event) {
            return _vm.updateValue(field.name, field.exportValue);
          }
        }
      }) : field.type === 'choice' ? _c('select', {
        key: field.id,
        staticClass: "pdf-form-field pdf-choice-field",
        style: field.style,
        attrs: {
          "aria-label": field.name,
          "multiple": field.multiSelect
        },
        domProps: {
          "value": _vm.fieldValue(field.name)
        },
        on: {
          "change": function change($event) {
            return _vm.updateChoice(field, $event);
          }
        }
      }, _vm._l(field.options, function (option) {
        return _c('option', {
          key: "".concat(field.id, "-").concat(option.value),
          domProps: {
            "value": option.value
          }
        }, [_vm._v(_vm._s(option.label))]);
      }), 0) : _vm._e()];
    })], 2)]);
  }), 0)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('strong', [_vm._v("Pripravujem editovateľnú žiadosť")]), _c('span', [_vm._v("Načítavam strany a formulárové polia…")])]);

}]

export { render, staticRenderFns }